<template>
  <div class="live_information_details__yQVOw">
    <div class="video_information_container__8Dvwr">
      <div class="video_information_row__HrQ0z">
        <h2 class="video_information_title__jrLfG" style="overflow-wrap: break-word">{{ settings.title }}</h2>
      </div>
      <div class="video_information_row__HrQ0z">
        <a
          class="video_information_thumbnail__KZZ9O video_information_is_live__+p9sK"
          href="/0dad8baf12a436f722faa8e5001c5011"
          ><img width="60" height="60" src="@/assets/icon.webp" class="video_information_image__z6H2l" alt="" /><span
            class="video_information_badge__gBbkk"
            ><em class="live_badge_container__0hge3 live_badge_red__9Fgzw live_badge_small__16qzY"
              ><svg
                width="23"
                height="7"
                viewBox="0 0 39 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5918 9.94881V12.4211H0.177979V0.368866H3.38116V9.94881H8.5918ZM13.8997 0.368866V12.4211H10.6965V0.368866H13.8997ZM23.7898 12.4211L27.8047 0.368866H24.296L21.8783 9.42263H21.8085L19.3821 0.368866H15.7425L19.7574 12.4211H23.7898ZM38.2796 9.94881V12.4211H29.6475V0.368866H38.2796V2.84111H32.8507V5.23819H37.9566V7.49327H32.8507V9.94881H38.2796Z"
                  fill="white"
                ></path></svg
              ><span class="blind">LIVE</span></em
            ></span
          ></a
        >
        <div class="video_information_channel__SpJgm">
          <p class="video_information_name__+eQ6K">
            <a class="video_information_link__2OrbG" href="/0dad8baf12a436f722faa8e5001c5011"
              ><span class="name_ellipsis__Hu9B+"
                ><span class="name_text__yQG50">{{ settings.streamerNickname }}</span></span
              ></a
            >
          </p>
          <p class="video_information_play__Xm51D">
            <span class="video_information_game__18XV7"
              ><svg
                width="22"
                height="17"
                viewBox="0 0 22 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="video_information_icon_play__m57wk"
                aria-hidden="true"
              >
                <rect y="4" width="22" height="13" rx="6.5" fill="#00FFA3" fill-opacity="0.9"></rect>
                <rect x="10" width="2" height="6" rx="1" fill="#00FFA3" fill-opacity="0.9"></rect>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.8199 13.0874C14.4336 13.0874 14.1209 12.7744 14.1209 12.3884C14.1209 12.0023 14.4336 11.6893 14.8199 11.6893C15.2059 11.6893 15.519 12.0023 15.519 12.3884C15.519 12.7744 15.2057 13.0874 14.8199 13.0874Z"
                  fill="#141517"
                  stroke="#141517"
                  stroke-width="0.8"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9168 10.9903C16.5307 10.9903 16.218 10.6774 16.218 10.2911C16.218 9.90508 16.5307 9.59229 16.9168 9.59229C17.3032 9.59229 17.6161 9.90508 17.6161 10.2911C17.6161 10.6772 17.303 10.9903 16.9168 10.9903Z"
                  fill="#141517"
                  stroke="#141517"
                  stroke-width="0.8"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.8199 8.89324C14.4336 8.89324 14.1209 8.58018 14.1209 8.19431C14.1209 7.80824 14.4336 7.49518 14.8199 7.49518C15.2059 7.49518 15.519 7.80824 15.519 8.19431C15.519 8.58018 15.2057 8.89324 14.8199 8.89324Z"
                  fill="#141517"
                  stroke="#141517"
                  stroke-width="0.8"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.7227 10.9903C12.3368 10.9903 12.0238 10.6774 12.0238 10.2911C12.0238 9.90508 12.3368 9.59229 12.7227 9.59229C13.1091 9.59229 13.4219 9.90508 13.4219 10.2911C13.4219 10.6772 13.1091 10.9903 12.7227 10.9903Z"
                  fill="#141517"
                  stroke="#141517"
                  stroke-width="0.8"
                ></path>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.92691 10.6408C9.92691 10.8317 9.76823 10.9903 9.57739 10.9903H7.82981V12.7379C7.82981 12.9282 7.67087 13.0874 7.4803 13.0874H6.78127C6.59043 13.0874 6.43175 12.9282 6.43175 12.7379V10.9903H4.68417C4.49386 10.9903 4.33466 10.8317 4.33466 10.6408V9.94179C4.33466 9.75095 4.49386 9.59227 4.68417 9.59227H6.43175V7.80495C6.43175 7.61438 6.59043 7.49518 6.78127 7.49518H7.4803C7.67087 7.49518 7.82981 7.61438 7.82981 7.80495V9.59227H9.57739C9.76823 9.59227 9.92691 9.75095 9.92691 9.94179V10.6408Z"
                  fill="#141517"
                ></path></svg
              ><a href="/search?query=PUBG: 배틀그라운드">{{ settings.gameTitle }}</a></span
            >
          </p>
          <div class="video_information_live_data__KuWvk">
            <div class="video_information_live_count__c9xWq">
              <strong class="video_information_count__Y05sI video_information_highlight__4529f"
                >현재 2,687 시청중</strong
              ><span class="video_information_count__Y05sI">누적 4,936</span>
            </div>
            <span class="video_information_time__G95w+">00:21:40 스트리밍 중</span>
          </div>
        </div>
        <div class="video_information_control__UTm8Z">
          <button
            type="button"
            class="button_container__x044H button_medium__r15mw button_capsule__tU-O- button_highlight__K-Up9"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.0198 6.77894C8.94243 3.98296 3.5 4.39829 3.5 8.6267C3.5 10.6135 4.97427 13.2199 9.20416 15.9063C9.30036 15.9674 9.6265 16.1413 10 16.1427C10.3735 16.1442 10.6793 15.9801 10.7622 15.9276C15.0179 13.2337 16.5 10.6188 16.5 8.6267C16.5 4.42263 11.1031 3.96638 10.0198 6.77894Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linejoin="round"
              ></path></svg
            >팔로우</button
          ><button
            type="button"
            class="button_container__x044H button_medium__r15mw button_capsule__tU-O- button_white__j8+mY"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10H13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
              <path d="M10 7L10 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
              <rect x="2" y="2" width="16" height="16" rx="8" stroke="currentColor" stroke-width="2"></rect></svg
            >구독</button
          ><button
            type="button"
            class="button_container__x044H button_medium__r15mw button_circle__lcf+O button_dark__cw8hT"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle
                cx="2.3001"
                cy="1.89998"
                r="1.7"
                transform="rotate(-90 2.3001 1.89998)"
                fill="currentColor"
              ></circle>
              <circle
                cx="8.00029"
                cy="1.89998"
                r="1.7"
                transform="rotate(-90 8.00029 1.89998)"
                fill="currentColor"
              ></circle>
              <circle
                cx="13.7"
                cy="1.89998"
                r="1.7"
                transform="rotate(-90 13.7 1.89998)"
                fill="currentColor"
              ></circle></svg
            ><span class="blind">더보기 메뉴</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  settings: {
//         title: "일요일 방송!",
//         streamerNickname: "펫집사",
//         gameTitle: "아시안 월드컵 시청중",
//       },

// profileImageUrl
// https://ssl.pstatic.net/cmstatic/nng/img/img_anonymous_square_gray_opacity2x.png?type=f120_120_na
// @/assets/icon.webp
export default {
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style src="./chzzk.main.47bcbdf5.css" scoped></style>
